import { Injectable } from '@angular/core';
import jsPDF from 'jspdf';
import autoTable, { Styles } from 'jspdf-autotable';
import { reportConstants } from '../../common/constants';
import { FractionComponent, FractionReports } from '../../models/project';

@Injectable({
    providedIn: 'root'
})
export class ReportPDFFractionRenderService {
    private commonStyles = {
        fontSize: 8,
        textColor: [0, 0, 0],
        fillColor: false,
        lineColor: [0, 0, 0],
        lineWidth: reportConstants.tableLinewidth
    };

    FractionAppendix(doc: jsPDF, marginSize: number, fractionExp: FractionReports): void {
        if (fractionExp !== undefined && fractionExp !== null) {
            doc.addPage();
            let tableStartY = marginSize - 5;
            marginSize += 5;
            doc.setFontSize(10);
            doc.setFont(reportConstants.eMprintCondensedBold);
            doc.text(reportConstants.fractionAppendix, marginSize + 30, tableStartY);
            tableStartY += 5;
            const setMargin = marginSize + 30;
            autoTable(doc, {
                head: [
                    [
                        { content: reportConstants.compound, colSpan: 2, styles: { halign: reportConstants.center } },
                        { content: '', styles: { halign: reportConstants.center } },
                        { content: reportConstants.fractionMWPDF, styles: { halign: reportConstants.center } },
                        { content: reportConstants.fractionDensityPDF, styles: { halign: reportConstants.center } }
                    ]
                ],
                body: fractionExp.components.map((val: FractionComponent) => [val.component, val.componentName, val.StarsCol, val.mw, val.density]),
                startY: Math.round(tableStartY),
                theme: reportConstants.plain,
                margin: { left: setMargin, right: setMargin },
                styles: this.commonStyles as Partial<Styles>,
                headStyles: {
                    fontSize: 7,
                    halign: reportConstants.center,
                    textColor: [0, 0, 0],
                    fillColor: false,
                    fontStyle: reportConstants.normal,
                    font: reportConstants.eMprintCondensedBold,
                    cellPadding: { top: 0.5, bottom: 0.5 }
                },
                bodyStyles: {
                    fontSize: 7,
                    halign: reportConstants.center,
                    textColor: [0, 0, 0],
                    fillColor: false,
                    font: reportConstants.eMprintCondensedRegular,
                    cellPadding: { top: 0.2, bottom: 0.2 }
                },
                didParseCell: function (data) {
                    if (data.section === reportConstants.body && (data.column.index === 0 || data.column.index === 1 || data.column.index === 2)) {
                        data.cell.styles.font = reportConstants.eMprintCondensedBold;
                    }
                }
            });
            tableStartY = (doc.lastAutoTable?.finalY ?? doc.internal.pageSize.getHeight()) + 5;
            doc.setFontSize(6);
            doc.setFont(reportConstants.eMprintCondensedRegular);
            doc.text(reportConstants.fractionCommentsPDF1, setMargin, tableStartY, { maxWidth: doc.internal.pageSize.getWidth() - 2 * setMargin });
            tableStartY += 5;
            doc.text(reportConstants.fractionCommentsPDF2, setMargin, tableStartY);
            tableStartY += 5;
            doc.text(reportConstants.fractionCommentsPDF3, setMargin, tableStartY);
            tableStartY += 5;
            doc.text(reportConstants.fractionCommentsPDF4, setMargin, tableStartY, { maxWidth: doc.internal.pageSize.getWidth() - 2 * setMargin });
        }
    }
}